<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
        <a-form-model-item
          label="所属管线"
          prop="pipelineId"
        >
          <a-select
            v-model="form.pipelineId"
            placeholder="请选择所属管线"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in pipelineList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.pipelineName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
    <div class="bottom-control">
      <a-space>
        <a-button
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
        >
          保存
        </a-button>
        <a-button
          type="dashed"
          @click="cancel"
        >
          取消
        </a-button>
      </a-space>
    </div>
  </a-form-model>
  <a-table :columns="this.columns" :data-source="this.deviceList" :pagination="false"></a-table>
</a-drawer>
</template>

<script>
import { updateDeviceDistribution, listPipeline } from '@/api/saifuneng/device'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      pipelineList: [],
      customList: [],
      deviceList: [],
      // 表单参数
      form: {
        idList: [],
        pipelineId: undefined
      },
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'deviceCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '位置描述',
          dataIndex: 'locationDescription',
          ellipsis: true,
          align: 'center'
        }
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        pipelineId: [
          { required: true, message: '所属管线不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getPipelineList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        idList: [],
        pipelineId: undefined
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 分配 */
    handleDistribution(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '分配'
      this.deviceList = row
      row.forEach(item => {
        this.form.idList.push(item.id)
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          updateDeviceDistribution(this.form).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }


  }
}
</script>
